// noinspection JSUnresolvedReference

(function(app) {
    let colorMap = {};
    const elements = {};

    app.ColorSelection = {
        init() {
            colorMap = app.Store.getState('colorMap');

            elements.textDisplayEl = document.querySelector(`.wdpp-display--text-color`);
            elements.textLabelEl = document.querySelector(`.wdpp-label-color.wdpp-line`);
            elements.textLabelPriceEl = document.querySelector(`.wdpp-label-color-price.wdpp-line`);

            app.Store.subscribe('textColor', (color) => this.updateColorDisplay(color));

            const colorGrid = document.querySelector(`.wdpp-color-grid.wdpp-line[data-is-for-text="true"]`);
            
            // Validate required elements
            if (!app.Utils.validateElements('color inputs for text', {
                'color grid': '.wdpp-color-grid.wdpp-line[data-is-for-text="true"]'
            })) {
                return;
            }

            const colorElements = colorGrid.querySelectorAll('.wdpp-color-box.wdpp-line');

            colorElements.forEach(colorElement => {
                const colorName = colorElement.getAttribute('data-color');
                colorElement.style.backgroundColor = colorMap[colorName].hex;

                colorElement.addEventListener('click', () => {
                    colorElements.forEach(el => el.classList.remove('selected'));
                    colorElement.classList.add('selected');
                    app.Store.setState('textColor', colorName);
                });
            });

            app.Store.subscribe('canvasReady', () => {
                const defaultColor = colorGrid.getAttribute('data-default-color');
                if (defaultColor) {
                    const defaultColorElement = Array.from(colorElements).find(el =>
                        el.getAttribute('data-color') === defaultColor
                    );
                    if (defaultColorElement) {
                        defaultColorElement.click();
                    }
                } else if (colorElements.length > 0) {
                    colorElements[0].click();
                }
            });
        },

        updateColorDisplay(colorName) {
            if (elements.textDisplayEl) {
                elements.textDisplayEl.textContent = colorName;
                elements.textDisplayEl.style.setProperty('--display-color', colorMap[colorName].hex);
            }

            if (elements.textLabelEl) {
                elements.textLabelEl.textContent = colorMap[colorName].friendlyName;
            }

            if (elements.textLabelPriceEl) {
                const priceMultiplier = colorMap[colorName].priceMultiplier;
                elements.textLabelPriceEl.textContent = priceMultiplier > 0 ? `(pris +${priceMultiplier * 100}%)` : '';
            }
        },

        /**
         * Get the color data for cart export
         * @returns {object} The color data for the cart
         */
        getCartData() {
            return {
                textColor: app.Store.getState('textColor')
            };
        },

        /**
         * Get the color data for price calculation
         * @returns {object} The color data for the price
         */
        getPriceData() {
            return {
                textColor: app.Store.getState('textColor')
            };
        }
    };
})(window.app = window.app || {});